import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { AlertDialogComponent } from "@intocare-medapp/design-system";
import { IonButton, IonButtons, IonHeader, IonIcon, IonToolbar } from "@ionic/angular/standalone";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs/operators";
import { addIcons } from "ionicons";
import { cloudOfflineOutline, cloudUploadOutline, cloudOutline } from "ionicons/icons";
import { injectIsOfflineDurationDisplay, NetworkService } from "../shared";
import { Router } from "@angular/router";
import { SyncModel } from "../shared/offline";

@Component({
	selector: "ic-app-alert-banner",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AlertDialogComponent, IonButton, IonIcon, TranslatePipe, IonToolbar, IonHeader, IonButtons],
	templateUrl: "./app-alert-banner.component.html",
	styles: `
		:host {
			/* Minimal height is by default much larger, we want a more compact banner here. */
			ion-toolbar {
				--min-height: 2rem;
			}
			/* TODO: Find out why icons and text on buttons here is not really aligned with the full height. */
			.sc-ion-buttons-md-s ion-button {
				& span {
					margin-top: 2px;
				}
				& ion-icon {
					margin-top: 1px;
				}
			}
		}
	`,
})
export class AppAlertBannerComponent {
	private readonly translateService = inject(TranslateService);
	private readonly networkService = inject(NetworkService);
	private readonly router = inject(Router);
	private readonly syncModel = inject(SyncModel);

	constructor() {
		addIcons({ cloudUploadOutline, cloudOfflineOutline, cloudOutline });
	}

	protected readonly syncStatusInProgressCount = toSignal(this.syncModel.offlineActionsCount$, { initialValue: 0 });
	protected readonly syncStatusInProgress = computed(() => this.syncStatusInProgressCount() > 0);
	protected onSyncStatusClick() {
		return this.router.navigate(["/sync-actions"]);
	}

	protected readonly isOffline = this.networkService.isOffline;
	protected readonly isOfflineDurationDisplay = injectIsOfflineDurationDisplay();
	protected readonly isOfflineInfoDialogOpen = signal(false);
	protected readonly isOfflineInfoDialogMessage = toSignal(
		this.translateService.get("appAlertBanner.onlineStatus.offlineAlertMessageHTML").pipe(
			map(
				(message) => `<div class="ion-text-center">
	<ion-icon name="cloud-offline-outline" class="icon-large"></ion-icon><br/>
	${message}
</div>`,
			),
		),
	);
}
